import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { SettingsService } from './settings.service';

@Injectable({
    providedIn: 'root'
})
export class SessionService {

    // sesion de usuario
    private session: Session = null;

    constructor(
        private router: Router,
        private http: HttpClient,
        private settings: SettingsService,
    ) {

    }

    /**
     * Almacena la sesion en memoria
     * @param data datos de sesion de usuario
     */
    setSession(data: Session) {
        this.session = data;
        localStorage.setItem('session', JSON.stringify(data));
    }

    existSession() {
        return this.session !== null;
    }
    /**
     * Retorna el token de acceso del usuario
     */
    public getAccessToken(): string {
        return localStorage.getItem('session') ? JSON.parse(localStorage.getItem('session')).token : null;
        // return this.session.token;
    }

    /**
     * Actualiza el token/sesion del usuario
     */
    public refreshToken(): void {
    }

    logout(path = 'login'): void {
        localStorage.clear();
        this.session = null;
        this.router.navigate([path]);
    }

    /**
     * Retorna los módulos del usuario almacenado en el storage
     */
    public getModulos(): any {
        return localStorage.getItem('session') ? JSON.parse(localStorage.getItem('session')).menuPermisos : [];
    }

    setModulo(data: any) {
        localStorage.setItem('modulo', JSON.stringify(data));
    }

    getModulo(): any {
        return JSON.parse(localStorage.getItem('modulo'));
    }

    getMenuList(): any {
        let modulo = this.getModulo();
        return this.getModulos().filter((e) => e.modulo.toUpperCase().includes(modulo.toUpperCase()))
    }


    getTokenModulo(moduloId: number): Observable<any> {
        return this.http.post(`${this.settings.URL_BASE}login/actualizar_token`, { moduloId })
    }

    reemplazarTokenLocal(data: any) {
        const session = JSON.parse(localStorage.getItem('session'));
        session.token = data.token;
        session.moduloId = data.moduloId;
        localStorage.setItem('session', JSON.stringify(session));
        this.session = session;
    }
}

export interface Session {
    token: string;
    refreshToken: string;
    usuario: string;
}